module.exports = __webpack_public_path__ + "static/media/proxy-established-yes.a3252432.svg";